// TDIC: ErrorPage.jsx added
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Icon, Button } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import styles from './ErrorPage.module.scss';
import messages from './ErrorPage.messages';

const ErrorPage = (props) => {
    const translator = useContext(TranslatorContext);

    const { history } = props;

    const goToHome = () => {
        history.push('/home');
    };

    return (
        <div className={styles.errorContainer}>
            <div className={styles.errorContainer}>
                <Icon icon="mi-report" className={styles.errorIcon} />
            </div>
            <div className={styles.errorMessage}>
                {translator(messages.unableToAccessPage)}
            </div>
            <div className={styles.backToHomePage}>
                <Button onClick={goToHome}>
                    {translator(messages.backToHomePage)}
                </Button>
            </div>
        </div>
    );
};

ErrorPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};

export default withRouter(ErrorPage);
